import { YinzCamAppServer } from './YinzCamAppServer';
import { YinzCamAPI } from 'yinzcam-api';

export abstract class YinzCamSoccerAppServer extends YinzCamAppServer {
  public constructor(api: YinzCamAPI) {
    super(api, 'V1/');
  }
}
